import { M_PER_CUSTOM_02_Schema } from './M_PER_CUSTOM_02_Schema';
import { mapParamsBySchema } from '../../../../util';
import Global from '../../../../Services/Common/Global';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import useSearchMutaion from '../../../../Hooks/apis/useSearchMutaion';
import useSaveMutation from '../../../../Hooks/apis/useSaveMutaion';
import useDeleteMutation from '../../../../Hooks/apis/useDeleteMutaion';

export const useSearch1 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      M_PER_CUSTOM_02_Schema.mapper.search1,
      context
    );
    return apiRequest('post', Global.urls.Permit.getPerCustomR5, params);
  }, successOptions);
};

export const useSearch2 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      M_PER_CUSTOM_02_Schema.mapper.search2,
      context
    );
    return apiRequest('post', Global.urls.Utility.GetSafetyManager, params);
  }, successOptions);
};

export const useSave1 = () =>
  useSaveMutation(async (context) => {
    const payload = mapParamsBySchema(
      M_PER_CUSTOM_02_Schema.mapper.save1,
      context
    );

    return apiRequest('post1', Global.urls.Permit.savePerCustomU3, payload);
  });

export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (context) => {
    const payload = mapParamsBySchema(
      M_PER_CUSTOM_02_Schema.mapper.delete1,
      context
    );
    return apiRequest('post', Global.urls.Permit.deletePerCustomD1, payload);
  }, options);
};
